export default __webpack_public_path__ + "static/media/travel world.85bae440.png";